"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _utils = require("./../../utils");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function Khal() {
  (0, _react.useEffect)(function () {
    (0, _utils.windowAddEventListener)(function () {
      (0, _utils.scaleAnimation)('partners-animation-fake');
    }, 1);
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "partners-level-banner-logo",
    id: "partners-animation-fake"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      background: 'url(https://staticintl.cloudcachetci.com/cms/backend-cms/hw5R003_ANI4%28120x140%29.png)'
    },
    className: "level-banner-logo__icon is-enter"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "partners-curve"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: "partners-img-1",
    src: "https://staticintl.cloudcachetci.com/cms/backend-cms/r8k6070_ANI1.png"
  }), /*#__PURE__*/_react["default"].createElement("img", {
    className: "partners-img-2",
    src: "https://staticintl.cloudcachetci.com/cms/backend-cms/HcEW827_ANI2.png"
  }), /*#__PURE__*/_react["default"].createElement("img", {
    className: "partners-img-3",
    src: "https://staticintl.cloudcachetci.com/cms/backend-cms/9sNG999_ANI3.png"
  })), /*#__PURE__*/_react["default"].createElement("img", {
    className: "partners-img-bg",
    src: "https://staticintl.cloudcachetci.com/cms/backend-cms/Bfxj871_BG.png"
  }));
}

var _default = Khal;
exports["default"] = _default;